

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const GETKRAKPIAPPRAISALFORM= createAsyncThunk(
  "getKraKpiAppraisalForm/getKraKpiAppraisalForm",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getKraKpiAppraisalFormSlice = createSlice({
  name: "getKraKpiAppraisalFormSlice",
  initialState: {
    getKraKpiAppraisalForm: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetKraKpiAppraisalForm: (state) => {
        state.getKraKpiAppraisalForm.loading = false
        state.getKraKpiAppraisalForm.error = false
        state.getKraKpiAppraisalForm.data = []
        state.getKraKpiAppraisalForm.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETKRAKPIAPPRAISALFORM.fulfilled, (state, action) => {
      state.getKraKpiAppraisalForm = {
        ...state.getKraKpiAppraisalForm,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETKRAKPIAPPRAISALFORM.pending, (state, action) => {
      state.getKraKpiAppraisalForm = {
        ...state.getKraKpiAppraisalForm,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETKRAKPIAPPRAISALFORM.rejected, (state, action) => {
      state.getKraKpiAppraisalForm = {
        ...state.getKraKpiAppraisalForm,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getKraKpiAppraisalFormAction = {
    GETKRAKPIAPPRAISALFORM,
};

export { getKraKpiAppraisalFormAction };
export default getKraKpiAppraisalFormSlice.reducer;
export const {setInitialStateOfgetKraKpiAppraisalForm} = getKraKpiAppraisalFormSlice.actions
